import {
  Assessments,
  Assessment,
  QuestionData,
  State,
  AssessmentData,
} from 'store/store';

export const resultsKeyMapToSuspendData = {
  answer: 0,
  attemptCount: 1,
  correctAnswer: 2,
  id: 3,
  isCorrect: 4,
  isLocked: 5,
  navigateToResults: 6,
  questionName: 7,
  submitButtonLabel: 8,
};

export const resultsKeyMapFromSuspendData = {
  0: 'answer',
  1: 'attemptCount',
  2: 'correctAnswer',
  3: 'id',
  4: 'isCorrect',
  5: 'isLocked',
  6: 'navigateToResults',
  7: 'questionName',
  8: 'submitButtonLabel',
};

function getResultsMinified(results: QuestionData) {
  const resultsMinified = Object.values(results).reduce((accA, currA) => {
    const keysRemapped = Object.keys(currA).reduce((accB, currB) => {
      return {
        ...accB,
        [resultsKeyMapToSuspendData[currB]]: currA[currB],
      };
    }, {});

    return {
      ...accA,
      [currA.id]: {
        ...keysRemapped,
      },
    };
  }, {});

  return resultsMinified;
}

function getResultsMaxified(results: QuestionData) {
  const resultsMaxified = Object.values(results).reduce((accA, currA) => {
    const keysRemapped = Object.keys(currA).reduce((accB, currB) => {
      return {
        ...accB,
        [resultsKeyMapFromSuspendData[currB]]: currA[currB],
      };
    }, {});

    return {
      ...accA,
      [currA[3]]: {
        ...keysRemapped,
      },
    };
  }, {});

  return resultsMaxified;
}

function transformAssessmentsToSuspendData(
  assessments: Assessments,
  state: State = {} as State
) {
  // console.log(
  //   'assessments raw bytes size ?',
  //   JSON.stringify(assessments).length
  // );

  const assessmentsMinified = Object.keys(assessments).reduce((acc, key) => {
    const assessment = assessments[key];

    const sId =
      state.topicsIdSIdMapping.idToSId[key] || state.blocks[key]?.props?.sId;
    const assessmentSId = String(sId) || key;
    //
    //
    // JSON.parse(JSON.stringify(assessment));
    const { data, results } = structuredClone(assessment);
    const resultsUpdatingIdToSId = {
      ...results,
    };

    //
    Object.keys(resultsUpdatingIdToSId as any).forEach(k => {
      if (state?.blocks) {
        //
        const sId =
          state.assessmentQuestionIdSIdMapping.idToSId[k] ||
          state.blocks[k]?.props?.sId;
        if (sId) {
          resultsUpdatingIdToSId[k]['id'] = sId;
        }
        //
      }
    });

    const resultsMinified = getResultsMinified(
      resultsUpdatingIdToSId as QuestionData
    );

    const assessmentMinified = {
      d: {
        ...data,
      },
      r: {
        ...resultsMinified,
      },
    };

    return {
      ...acc,
      [assessmentSId]: assessmentMinified,
    };
  }, {});

  // console.log(
  //   'assessments minified bytes size ?',
  //   JSON.stringify(assessmentsMinified).length
  // );

  const assessmentsBytes = JSON.stringify(assessments).length;
  const assessmentsMinifiedBytes = JSON.stringify(assessmentsMinified).length;
  const savings =
    ((assessmentsBytes - assessmentsMinifiedBytes) / assessmentsBytes) * 100;

  // console.log('% savings :', savings.toFixed());

  return assessmentsMinified;
}

function transformAssessmentsFromSuspendData(
  assessments: Assessments,
  state: State = {} as State
) {
  return Object.keys(assessments).reduce((acc, key) => {
    const assessment = assessments[key];
    const assessmentId =
      state.topicsIdSIdMapping.sIdToId[key] ||
      Object.values(state.blocks).find(block => {
        return block?.props?.sId === Number(key);
      })?.id ||
      ''; // if we're undefined here. problems

    const { d, r } = assessment;
    const resultsUpdatingSIdToId = {
      ...r,
    } as QuestionData;

    //
    Object.values(resultsUpdatingSIdToId).forEach((entry: any) => {
      if (state?.blocks) {
        const id =
          state.assessmentQuestionIdSIdMapping.sIdToId[entry['3']] ||
          Object.values(state.blocks).find(block => {
            return block?.props?.sId === Number(entry['3']);
          })?.id;

        if (id) {
          entry['3'] = id;
        }
        //
      }
    });

    const resultsMaxified = getResultsMaxified(
      resultsUpdatingSIdToId as QuestionData
    );

    const assessmentMaxified = {
      data: {
        ...d,
      },
      results: {
        ...resultsMaxified,
      },
    };

    return {
      ...acc,
      [assessmentId]: assessmentMaxified,
    };
  }, {});
}

export {
  transformAssessmentsToSuspendData,
  transformAssessmentsFromSuspendData,
};
